<template>
  <div class="card">
    <div class="title">
      {{ title }}
    </div>
    <div
      v-if="type === 'homePage'"
      class="row-list-box"
      :style="{ marginTop: $vw(23)}"
    >
      <div class="row-list">
        <!-- 浏览器主页卡片 -->
        <template v-if="type==='homePage'">
          <div
            v-for="homePage in data"
            :key="homePage.id"
            v-lazy:background-image="$imgHook(homePage.cover)"
            class="list-item homePage"
            @click="linkTo(homePage.link, homePage.id)"
          >
            <!-- <div class="homePage-wrap">
              <div class="homePage-title">{{ homePage.title | cutFont(8) }}</div>
              <div class="homePage-introduction">{{ homePage.introduction | cutFont(15) }}</div>
            </div> -->
          </div>
        </template>

      </div>
    </div>
    <div
      v-if="type !== 'homePage'"
      class="column-list-box"
      :style="{ marginTop: type=='plugin' ? $vw(5) : $vw(15) }"
    >
      <div class="column-list">
        <!-- 文章卡片 -->
        <template v-if="type==='article'">
          <div
            v-for="article in cutData"
            :key="article.id"
            class="article"
            @click="linkTo(article.link, article.id)"
          >
            <div
              class="article-left"
              :style="{ backgroundImage: `url('${$imgHook(article.cover)}')` }"
            />
            <div class="article-right">
              <div class="article-title van-ellipsis">{{ article.title }}</div>
              <div class="article-introduction van-ellipsis">{{ article.introduction }}</div>
            </div>
          </div>
        </template>

        <!-- 插件卡片 -->
        <template v-if="type === 'plugin'">
          <via-plugin-row-card
            v-for="plugin in cutData"
            :key="plugin.id"
            class="plugin-list-card"
            :plugin-id="plugin.id"
            :icon="plugin.icon"
            :icon-color="plugin.iconColor"
            :icon-bg-color="plugin.iconBgColor"
            :name="plugin.name"
            :update-time="Number(plugin.updateTime)"
            :author="`简介: ${plugin.introduction}`"
          />
        </template>
      </div>
    </div>
  </div>
</template>
<script>
import { linkTo } from '~/utils/func'
import { cutFont } from '~/utils/filters'
import ViaPluginRowCard from 'components/common/via-plugin-row-card'

export default {
  name: 'RecommendCard',
  components: {
    [ViaPluginRowCard.name]: ViaPluginRowCard
  },
  filters: {
    cutFont
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: ''
    },
    data: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      cutData: []
    }
  },
  watch: {
    data: {
      immediate: true,
      handler(newValue, oldValue) {
        this.cutData = newValue.slice(0, 10)
      }
    }
  },
  methods: {
    linkTo,
    goToPluginDetail(id) {
      this.$router.$push({
        name: 'PluginDetail',
        params: {
          id
        }
      })
    }
  }
}
</script>

<style scoped>
.card {
  width: 375px;
  display: flex;
  flex-direction: column;
}
.title {
  font-size: 20px;
  font-weight: 900;
  margin-left: 15px;
}
.row-list-box {
  width: 375px;
  display: -webkit-box;
  display: -moz-box;
  box-sizing: border-box;
  -webkit-overflow-scrolling:touch;
  overflow-x: scroll;
}
.row-list {
  height: 100%;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  padding: 20px 0 20px 15px;
}

/* article */
.article {
  width: 345px;
  display: flex;
  padding: 8px 0;
  margin: 0 15px;
  box-sizing: border-box;
}
.article-left {
  width: 50px;
  height: 50px;
  background-color: var(--light40);
  background-repeat: no-repeat;
  background-size: cover;
  border-radius: 8px;
}
.article-right {
  width: 280px;
  margin-left: 15px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 50px;
}
.article-title {
  font-size: 15px;
  color: var(--light40);
}
.article-introduction {
  font-size: 13px;
  color: var(--light60);
}

/* homePage */
.homePage {
  width: 100px;
  height: 177px;
  background-color: var(--light40);
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  margin-right: 20px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  overflow: hidden;
  box-shadow: var(--boxShadow-bottom);
}
.homePage-wrap {
  width: 100%;
  height: 40%;
  padding: 15px;
  box-sizing: border-box;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  /* background-color: rgba(0, 0, 0, 0.9); */
  background: linear-gradient(to bottom, rgba(255, 255, 255, 0),rgba(255, 255, 255, 1) 50%);
}
.homePage-title {
  font-size: 18px;
  font-weight: 900;
  color: var(--light50);
}
.homePage-introduction {
  font-size: 13px;
  color: var(--light60);
  margin-top: 8px;
}
</style>
